module.exports = __webpack_public_path__ + "img/embed-video.99b64706.png";